import React, { useMemo, useState, useEffect } from 'react';
import {
  Box,
  Typography,
} from '@mui/material';
import Grid from '@mui/material/Grid2';

import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import MarkunreadIcon from '@mui/icons-material/Markunread';
import NotificationsIcon from '@mui/icons-material/Notifications';

import {
  OffCanvas,
  Table,
  useMessageDispatch,
} from 'itaf';

import NotificationService from '../../services/NotificationService';

export default function NotificationCanvas({open, user}) {
  const setMessage = useMessageDispatch();

  const [notifications, setNotifications] = useState([]);
  const [isError, setError] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [isRefetching, setRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState('');
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  
  useEffect(() => {
    if (open) {
      setPagination({ pageIndex: 0, pageSize: 10 });
      fetchData();
    }
  }, [open])

  //if you want to avoid useEffect, look at the React Query example instead
  useEffect(() => {
    if (open) {
      fetchData();
    }
  }, [
    columnFilters,
    globalFilter,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
  ]);

  const fetchData = async () => {
    if (!notifications.length) {
      setLoading(true);
    } else {
      setRefetching(true);
    }

    // url.searchParams.set('size', `${pagination.pageSize}`);
    // url.searchParams.set('filters', JSON.stringify(columnFilters ?? []));
    // url.searchParams.set('globalFilter', globalFilter ?? '');
    // url.searchParams.set('sorting', JSON.stringify(sorting ?? []));

    const page = {
      pageSize: pagination.pageSize,
      pageNumber: pagination.pageIndex,
    }

    NotificationService.userNotifications(page)
    .then((response) => {
      if (response.ok) {
        (async () => {
          const result = await response.json();
          setNotifications(result.content);
          setRowCount(result.totalElements);
          setError(false);
        })();
      }
      else {
        setMessage({ hasError: true, text: 'Não foi possível carregar as notificações.' });
        setNotifications([]);
        setError(true);
      }
    })
    .catch((error) => {
      setError(true);
      console.error(error);
      setMessage({ hasError: true, text: 'Verifique se está logado e com conexão de internet.' });
    })
    .finally(() => {
      setLoading(false);
      setRefetching(false);
    });
  };

  const handleDrawerClose = () => {
    // setTimeout(() => { setMessage({ hasError: false, text: '' }); }, 10000);
    props.onCanvasClose(false);
  };

  const handleToggleExpand = (event, row) => {
    event.stopPropagation();
    row.toggleExpanded();
    if (!row.getIsExpanded() && !row.original.read) {
      NotificationService.markReadNote(row.original.id)
      .then((response) => {
        if (response.ok) {
          notifications[row.index] = { ...row.original, read: true };
          setNotifications([ ...notifications ]);
        }
      })
      .catch((error) => {
        console.log(error);
      });
    }
  };

  const initial = {
    columnVisibility: { 'mrt-row-expand': false },
  };

  const columns = useMemo(
    () => [
      {
        header: "Visualizado", accessorKey: "read", size: 56,
        enableHiding: false, enableColumnActions: false,
        muiTableBodyCellProps: {
          align: 'center',
        },
        Cell: ({ renderedCellValue, row }) => (
          renderedCellValue ? <MarkEmailReadIcon /> : <MarkunreadIcon />
        ),
      },
      {
        header: "Assunto", accessorKey: "subject", //minSize: '70', size: '80', maxSize: '100',
        enableHiding: false, enableColumnActions: false,
      },
    ],
    []
  );

  const buildTable = () => {
    return <Table
      title='Notificações'
      columns={columns}
      data={notifications}
      isLoading={isLoading}
      enableBottomToolbar={false}
      enableColumnActions={false}
      enableColumnOrdering
      enableExpandAll={false}
      enableExpanding={false}
      enableHiding={false}
      enablePinning={false}
      enablePagination
      pagination
      initialState={ initial }
      clickRowExpand={handleToggleExpand}
      details={({ row }) => (
        <Box
          sx={{
            display: 'grid',
            margin: 'auto',
            gridTemplateColumns: 'max-content',
            width: '100%',
          }}
        >
          <Typography>{row.original.content}</Typography>
        </Box>
      )}
    />;
  };

  return (
    <OffCanvas 
      showPanel={open}
      onClosedPanel={handleDrawerClose}
      isLoading={isLoading}
      header={{ title: `Notificações de ${user?.name}`, add: false, edit: false, icon: (<NotificationsIcon />) }}
      closeLabel="Fechar"
    >
      <Grid container spacing={2} sx={(theme) => ({ mt: theme.spacing(2) })}>
        <Grid size={12}>
          {buildTable()}
        </Grid>
      </Grid>
    </OffCanvas>
  );
};
